import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import Status from '../Status';

const IssuesFoundStatus = () => (
  <Status type="warning">
    <I18n k="statuses.issuesFound" />
  </Status>
);

IssuesFoundStatus.displayName = 'IssuesFoundStatus';

export default IssuesFoundStatus;
